import { IOT_SIM_LIST_LOOKUP } from "api/ApiPath";
import client from "api/client";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { IAlertSupportRepository } from "../domain/repositories/IAlertSupportRepository";
import { AlertSupportRequestModel } from "./models/AlertSupportRequestModel";
import { AlertSupportResponseModel } from "./models/AlertSupportResponseModel";

@injectable()
export class AlertSupportImpl implements IAlertSupportRepository {
  async getAlerts(
    params: AlertSupportRequestModel,
  ): Promise<ListBaseApiResponseModel<AlertSupportResponseModel>> {
    return await client?.get(IOT_SIM_LIST_LOOKUP.ALERT_SUPPORT, params);
  }
}
